export default __webpack_public_path__ + "static/media/m_event.c15b4a17.png";